

/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";
// customerRegister
// CUSTOMERREGISTER
const MENTORREQUIREMENTGETBYID = createAsyncThunk(
  "MentorRequirementGetById/MentorRequirementGetById",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const MentorRequirementGetByIdSlice = createSlice({
  name: "MentorRequirementGetByIdSlice",
  initialState: {
    MentorRequirementGetById: {
      ...defaultState.List,
      loading: false,
      error: false,
    },
  },
  reducers: {
    setInitialStateOfMentorRequirementGetById: (state) => {
      state.MentorRequirementGetById.loading = false
      state.MentorRequirementGetById.error = false
      state.MentorRequirementGetById.data = []
      state.MentorRequirementGetById.message = ''
    }
  },
  extraReducers: (builder) => {
    builder.addCase(MENTORREQUIREMENTGETBYID.fulfilled, (state, action) => {
      state.MentorRequirementGetById = {
        ...state.MentorRequirementGetById,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(MENTORREQUIREMENTGETBYID.pending, (state, action) => {
      state.MentorRequirementGetById = {
        ...state.MentorRequirementGetById,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(MENTORREQUIREMENTGETBYID.rejected, (state, action) => {
      state.MentorRequirementGetById = {
        ...state.MentorRequirementGetById,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const MentorRequirementGetByIdAction = {
  MENTORREQUIREMENTGETBYID,
};

export { MentorRequirementGetByIdAction };
export default MentorRequirementGetByIdSlice.reducer;
export const { setInitialStateOfMentorRequirementGetById } = MentorRequirementGetByIdSlice.actions
